import { absoluteUrl } from '../config/seo';

export function buildBreadcrumbJsonLd(items = []) {
  const list = items.filter((item) => item?.label);

  if (list.length === 0) return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: list.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      ...(item.to ? { item: absoluteUrl(item.to) } : {}),
    })),
  };
}
